import { FC, ReactNode } from 'react';
import { Conditional } from './Conditional';

interface ButtonProps {
  text?: string;
  textColor?: string;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  size?: 'small' | 'medium' | 'large';
  filled?: boolean;
  black?: boolean;
  disabled?: boolean;
  hover?: boolean;
  onClick: () => void;
}

export const Button: FC<ButtonProps> = ({
  text,
  textColor,
  leftIcon,
  rightIcon,
  size = 'medium',
  filled = false,
  black = false,
  disabled = false,
  hover = false,
  onClick,
}) => {
  const getTextStyling = () => {
    const colorClassName = `font-bold ${
      textColor ? textColor : black ? 'text-dark' : filled ? 'text-white' : 'text-sami-green'
    }`;

    const textSizeClassName =
      {
        small: 'text-xs',
        medium: 'text-sm',
        large: 'text-lg',
      }[size] || '';

    return `${colorClassName} ${textSizeClassName}`;
  };

  const getBackgroundStyling = () => {
    if (disabled) {
      return 'bg-lightest';
    } else if (filled && black) {
      return 'bg-white';
    } else if (filled) {
      return 'bg-sami-green';
    } else {
      return '';
    }
  };

  const getPaddingStyling = () => {
    switch (size) {
      case 'small':
        return 'px-0';
      case 'medium':
        return 'px-5';
      case 'large':
        return 'px-7';
    }
  };

  const getHoverStyling = () => {
    if (hover) {
      return 'hover:bg-black hover:bg-opacity-5';
    }
  };

  const getDisableStyling = () => {
    return `${disabled ? 'bg-lightest hover:text-opacity-40 cursor-not-allowed' : ''}`;
  };

  const getBorderStyling = () => {
    return `${black ? 'border border-text-dark' : ''}`;
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`flex flex-row items-center min-w-[90px] justify-center ${getPaddingStyling()} py-3 rounded-full outline-none ${getBackgroundStyling()} ${getTextStyling()} ${getDisableStyling()} ${getBorderStyling()} ${getHoverStyling()} `}
    >
      <Conditional condition={leftIcon !== undefined} trueRender={<div className="mr-2">{leftIcon}</div>} />
      <div className="truncate ">{text}</div>
      <Conditional
        condition={rightIcon !== undefined}
        trueRender={<div className="flex items-center ml-2">{rightIcon}</div>}
      />
    </button>
  );
};
